import Image from "next/image";
import { FunctionComponent } from "react";

import { Box, useTheme } from "@mui/system";

import { PageElementContainer } from "@components/PageContainer";

interface StyledImageProps {
  url: string;
  desc: string;
}

const StyledImage: FunctionComponent<StyledImageProps> = ({ url, desc }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [theme.breakpoints.up("mobile")]: {
          borderRadius: "5px",
        },
        [theme.breakpoints.up("tablet")]: {
          borderRadius: "10px",
        },
        [theme.breakpoints.up("desktop")]: {
          borderRadius: "20px",
        },
        overflow: "hidden",
        img: {
          display: "unset !important",
        },
        span: {
          display: "block !important",
        },
        boxShadow: 3,
        position: "relative",
        aspectRatio: "844 / 1498",
      }}
    >
      <Image src={url} alt={desc} fill />
    </Box>
  );
};

export const JustPreview = () => {
  const theme = useTheme();

  return (
    <PageElementContainer maxWidth="desktopXl">
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            [theme.breakpoints.up("mobile")]: {
              gap: "4px",
            },
            [theme.breakpoints.up("tablet")]: {
              gap: "12px",
            },
            [theme.breakpoints.up("desktop")]: {
              width: "980px",
              gap: "24px",
            },
            flex: 1,
          }}
        >
          <Box pt={"80px"} sx={{ flex: 1, minWidth: 0 }}>
            <StyledImage
              url="/just/summary.png"
              desc="Just summary screenshot"
            />
          </Box>

          <Box pb={"80px"} sx={{ flex: 1, minWidth: 0 }}>
            <StyledImage url="/just/login.png" desc="Just login screenshot" />
          </Box>

          <Box pt={"80px"} sx={{ flex: 1, minWidth: 0 }}>
            <StyledImage
              url="/just/transfers.png"
              desc="Just transfers screenshot"
            />
          </Box>
        </Box>
      </Box>
    </PageElementContainer>
  );
};
